import React from 'react'
import { css } from '@emotion/core'
import PageLoadingIndicator from '../shared/components/PageLoadingIndicator'
import HeritageBackdrop, { heritageBackdropSurfaceCss } from './HeritageBackdrop'
import { BROWSE_COPY } from './browse/copy'

const routeLoadingCss = css`
  min-height: 100vh;
`

const routeLoadingContentCss = css`
  position: relative;
  z-index: 1;

  [data-page-loading-indicator] {
    color: #ffffff;
  }

  p {
    color: #ffffff;
    font-size: 21px;
    font-weight: 600;
    line-height: 1.3;
    text-align: center;
  }

  svg {
    color: #dcefe4;
  }
`

/**
 * The loading screen for the Picture My Heritage route, shown while the lazy bundle resolves. It
 * is the first thing this route paints - nothing renders before React mounts - so it announces its
 * own label.
 *
 * It reuses HeritageBackdrop so the hand-off to the catalog is seamless: both paint the same map
 * over the same green. Re-declaring those layers here meant the palette and the 700px composition
 * switch lived in two places and could drift apart.
 */
export default function PmhRouteLoadingFallback() {
  return (
    <main css={[heritageBackdropSurfaceCss, routeLoadingCss]} data-pmh2-route-loading>
      <HeritageBackdrop />
      <div css={routeLoadingContentCss}>
        <PageLoadingIndicator announce label={BROWSE_COPY.loading.defaultValue} />
      </div>
    </main>
  )
}
